export const CONFIG = Object.freeze({
  env: process.env.NODE_ENV,
  baseUrl: process.env.REACT_APP_BASE_URL,
  gauthClientId: process.env.REACT_APP_GAUTH_CLIENT_ID,
  gauthOAuth: process.env.REACT_APP_GOOGLE_OAUTH2,
  redirectUrl: process.env.REACT_APP_REDIRECT_URL,
  adminUrl: process.env.REACT_APP_ADMIN_URL,
  chatUrl: process.env.REACT_APP_CHAT_URL
})